import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../utils/common'
import { getIsGretaAIChatFeedbackDown } from '../GretaAIChat.utils'

import { GretaAIChatFeedbackActions } from './GretaAIChatFeedbackActions'
import { GretaAIChatFeedbackComment } from './GretaAIChatFeedbackComment'
import { QA_NAME_GRETA_AI_CHAT_FEEDBACK_FORM } from './GretaAIChatFeedbackForm.constants'
import { GretaAIChatFeedbackPrivacy } from './GretaAIChatFeedbackPrivacy'
import { GretaAIChatFeedbackReasonField } from './GretaAIChatFeedbackReasonField'

import * as styles from './GretaAIChatFeedbackForm.module.css'

function GretaAIChatFeedbackForm({
  comment,
  reason,
  value,
  onCancel,
  onChangeComment,
  onChangeReason,
  onSubmit,
}) {
  const { t } = useTranslation()

  const isDown = getIsGretaAIChatFeedbackDown(value)

  const qaProps = getQaSelector({
    context: value,
    value: QA_NAME_GRETA_AI_CHAT_FEEDBACK_FORM,
  })

  return (
    <div {...qaProps} className={styles.form}>
      <div className={styles.title}>
        {isDown
          ? t('Greta.FeedbackTitleDownKey')
          : t('Greta.FeedbackTitleUpKey')}
      </div>

      {isDown ? (
        <GretaAIChatFeedbackReasonField
          reason={reason}
          onChangeReason={onChangeReason}
        />
      ) : null}

      <GretaAIChatFeedbackComment
        comment={comment}
        isDown={isDown}
        onChange={onChangeComment}
      />

      <GretaAIChatFeedbackPrivacy />

      <GretaAIChatFeedbackActions onCancel={onCancel} onSubmit={onSubmit} />
    </div>
  )
}

export default GretaAIChatFeedbackForm
